import {Component} from '@angular/core';
import {OrgantraegerNatuerlichePerson} from '@nachdigal';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-organtraeger-natuerliche-person',
  templateUrl: './organtraeger-natuerliche-person.component.html'
})
export class OrgantraegerNatuerlichePersonComponent extends FormBaseComponent<OrgantraegerNatuerlichePerson> {

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      vorname: [this.data.vorname, [
        this.validatorService.required(),
        this.validatorService.maxLength(72)
      ]],
      nachname: [this.data.nachname, [
        this.validatorService.required(),
        this.validatorService.maxLength(72)
      ]
      ]
    });
  }
}
